import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

// eslint-disable-next-line unicorn/prevent-abbreviations
export const env = createEnv({
  /*
   * Environment variables available on the client (and server).
   *
   * 💡 You'll get type errors if these are not prefixed with NEXT_PUBLIC_.
   */
  client: {
    // General
    NEXT_PUBLIC_ORIGIN: z.string(),
    NEXT_PUBLIC_SWAGGER_URL: z.string(),
    NEXT_PUBLIC_BOT_URL: z.string(),
    NEXT_PUBLIC_BOT_APP_URL: z.string(),
    NEXT_PUBLIC_REMOTE_IMAGE_HOSTNAMES: z.string().optional().default('placehold.co,storage.googleapis.com'),
    NEXT_PUBLIC_TON_CONNECT_MANIFEST_URL: z.string(),
    // Sentry
    NEXT_PUBLIC_SENTRY_DSN: z.string().optional(),
    // Direct Token Authentication
    NEXT_PUBLIC_USE_DIRECT_TOKEN: z.string().optional(),
    NEXT_PUBLIC_JWT_TOKEN: z.string().optional(),
  },
  /*
   * Due to how Next.js bundles environment variables on Edge and Client,
   * we need to manually destructure them to make sure all are included in bundle.
   *
   * 💡 You'll get type errors if not all variables from `server` & `client` are included here.
   */
  runtimeEnv: {
    NEXT_PUBLIC_ORIGIN: process.env.NEXT_PUBLIC_ORIGIN,
    NEXT_PUBLIC_SWAGGER_URL: process.env.NEXT_PUBLIC_SWAGGER_URL,
    NEXT_PUBLIC_BOT_URL: process.env.NEXT_PUBLIC_BOT_URL,
    NEXT_PUBLIC_BOT_APP_URL: process.env.NEXT_PUBLIC_BOT_APP_URL,
    NEXT_PUBLIC_REMOTE_IMAGE_HOSTNAMES: process.env.NEXT_PUBLIC_REMOTE_IMAGE_HOSTNAMES,
    NEXT_PUBLIC_TON_CONNECT_MANIFEST_URL: process.env.NEXT_PUBLIC_TON_CONNECT_MANIFEST_URL,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_USE_DIRECT_TOKEN: process.env.NEXT_PUBLIC_USE_DIRECT_TOKEN,
    NEXT_PUBLIC_JWT_TOKEN: process.env.NEXT_PUBLIC_JWT_TOKEN,
  },
});
